export default __webpack_public_path__ + "static/via-uniswap-56559cc1bd813bda2396c26c898ff4c0.png";